const lbDateInput = angular.module('app.lbDateInput', []);

lbDateInput.component('lbDateInput', {
  controllerAs: 'vm',
  controller: ['$rootScope', 'moment', 'ENUMS', 'dateTimeService', controller],
  template: require('./lbDateInput.html'),
  bindings: {
    name: '@',
    date: '=',
    minDate: '<',
    maxDate: '<',
    required: '<',
    class: '@',
    rangeFrom: '<',
    rangeTo: '<',
    parent: '@',
    change: '&',
    disabled: '<',
  },
});

function controller($rootScope, moment, ENUMS, dateTimeService) {
  const vm = this;
  const DATE_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);

  vm.openDatePicker = function ($event) {
    if ($event.handleObj.type !== 'focus') return;
    let settings = {
      input: $event.currentTarget,
      parent: vm.parent,
      minDate: moment(vm.minDate, DATE_FORMAT),
      maxDate: vm.maxDate ? moment(vm.maxDate, DATE_FORMAT) : moment().add(330, 'days'),
      defaultDate: moment(vm.date, DATE_FORMAT),
      rangeFrom: moment(vm.rangeFrom, DATE_FORMAT),
      rangeTo: moment(vm.rangeTo, DATE_FORMAT),
      callBack: dateCallBack,
    };
    $rootScope.$broadcast('openDatePicker', settings);
    $event.currentTarget.blur();
  };

  function dateCallBack(selection) {
    if (selection) {
      selection.date = moment(selection.date);
      vm.date = selection.date.format(DATE_FORMAT);
      if (vm.change) vm.change({ obj: selection });
    }
    $rootScope.$broadcast('closeDatePicker');
  }
}

export default lbDateInput;



// WEBPACK FOOTER //
// ./src/components/lbDateInput/index.js